import { render, staticRenderFns } from "./edit-student-policy-form.vue?vue&type=template&id=a380cbe4&scoped=true&"
import script from "./edit-student-policy-form.vue?vue&type=script&lang=js&"
export * from "./edit-student-policy-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a380cbe4",
  null
  
)

export default component.exports